import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PermissionSetInfoComponent } from './permission-set-info/permission-set-info.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { PermissionsetsComponent } from './permissionsets/permissionsets.component';
import { RolesComponent } from './roles.component';





const routes: Routes = [
 {path :"",component:RolesComponent ,children:[
   {path:"Permissions",component:PermissionsComponent},
   {path:"PermissionSets",component:PermissionsetsComponent},
   {path:"PermissionSetInfo/:id",component:PermissionSetInfoComponent},
   {path:"", redirectTo: 'Permissions', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class RolesRoutingModule { }
